import { useEffect, useState } from "react";
import { toast } from "sonner";
import { CheckCheck, Trash2, Inbox } from "lucide-react";
import { api } from "../../lib/api";

export const EnquiriesTable = () => {
  const [items, setItems] = useState(null);

  const load = () => api.get("/enquiries").then(({ data }) => setItems(data)).catch(() => setItems([]));
  useEffect(() => { load(); }, []);

  const markRead = async (id) => {
    await api.patch(`/enquiries/${id}/read`);
    toast.success("Ditanda sebagai dibaca");
    load();
  };

  const remove = async (id) => {
    await api.delete(`/enquiries/${id}`);
    toast.success("Pertanyaan dipadam");
    load();
  };

  if (items === null) return <p className="text-slate-500 dark:text-slate-400">Memuatkan...</p>;

  if (items.length === 0)
    return (
      <div className="bg-white dark:bg-slate-900/60 border border-slate-200 dark:border-white/10 rounded-2xl p-16 text-center shadow-sm dark:shadow-none" data-testid="enquiries-empty">
        <Inbox className="text-slate-400 dark:text-slate-600 mx-auto mb-4" size={40} />
        <p className="text-slate-500 dark:text-slate-400">Tiada pertanyaan buat masa ini.</p>
      </div>
    );

  return (
    <div className="space-y-4" data-testid="enquiries-list">
      <p className="text-slate-600 dark:text-slate-400 text-sm">
        <span className="font-semibold text-slate-900 dark:text-white">{items.filter((i) => !i.is_read).length}</span> belum dibaca daripada {items.length} pertanyaan
      </p>
      {items.map((e) => (
        <div
          key={e.id}
          data-testid={`enquiry-item-${e.id}`}
          className={`bg-white dark:bg-slate-900/60 border rounded-2xl p-6 shadow-sm dark:shadow-none transition-colors ${e.is_read ? "border-slate-200 dark:border-white/10" : "border-orange-500/70 dark:border-orange-500/40"}`}
        >
          <div className="flex flex-wrap items-start justify-between gap-4">
            <div>
              <div className="flex items-center gap-3 flex-wrap">
                <h3 className="font-heading font-semibold text-slate-900 dark:text-white">{e.name}</h3>
                {!e.is_read && (
                  <span className="text-[10px] uppercase tracking-wider bg-orange-600 text-white px-2 py-0.5 rounded-full font-bold">
                    Baru
                  </span>
                )}
                {e.service && (
                  <span className="text-xs bg-slate-100 dark:bg-slate-800 text-slate-700 dark:text-slate-300 px-3 py-1 rounded-full">{e.service}</span>
                )}
              </div>
              <p className="text-slate-500 dark:text-slate-400 text-sm mt-1">
                {e.email} · {e.phone}
              </p>
              <p className="text-slate-700 dark:text-slate-300 text-sm mt-3">{e.message}</p>
              <p className="text-slate-400 dark:text-slate-600 text-xs mt-3">{new Date(e.created_at).toLocaleString("ms-MY")}</p>
            </div>
            <div className="flex gap-2">
              {!e.is_read && (
                <button
                  onClick={() => markRead(e.id)}
                  data-testid={`mark-read-btn-${e.id}`}
                  className="flex items-center gap-1.5 text-xs bg-slate-100 dark:bg-slate-800 hover:bg-slate-200 dark:hover:bg-slate-700 text-slate-700 dark:text-slate-200 px-4 py-2 rounded-full transition-colors"
                >
                  <CheckCheck size={14} /> Dibaca
                </button>
              )}
              <button
                onClick={() => remove(e.id)}
                data-testid={`delete-enquiry-btn-${e.id}`}
                className="flex items-center gap-1.5 text-xs bg-red-50 dark:bg-red-900/40 hover:bg-red-100 dark:hover:bg-red-900/70 text-red-700 dark:text-red-300 px-4 py-2 rounded-full transition-colors"
              >
                <Trash2 size={14} /> Padam
              </button>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};
